module.exports = __webpack_public_path__ + "img/2235.543b1d4a.svg";